import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3f8bd36a")

_pushScopeId("data-v-3f8bd36a")
const _hoisted_1 = { class: "appliance-icon-item-area" }
const _hoisted_2 = { class: "appliance-icon-item" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.getIcon())
        ? (_openBlock(), _createBlock("img", {
            key: 0,
            class: "appliance-icon-item-icon",
            src: _ctx.getIcon()
          }, null, 8, ["src"]))
        : _createCommentVNode("", true)
    ])
  ]))
})